module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex tutor"
  }, [_c('div', {
    staticClass: "basic"
  }, [_c('tutor-profile', {
    attrs: {
      "tutor": _vm.tutor,
      "edit_id": _vm.edit_id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-AddBox"
  }, [_c('tutor-students-index', {
    attrs: {
      "tutor": _vm.tutor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-support"
  }, [_c('tutor-history', {
    attrs: {
      "tutor": _vm.tutor,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id,
      "type": "true"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54809039"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/TutorIndex.vue
// module id = 1377
// module chunks = 0